import React from "react";
import {
  AutoComplete,
  Button,
  Divider,
  Form,
  Image,
  Input,
  message,
  Modal,
  Select,
  Tooltip,
} from "antd";
import {
  CloudUploadOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import Avatar from "antd/es/avatar/avatar";
import SVGFileLoader from "./SVGFileLoader";
import RecipeTable from "./RecipeTable";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 5, span: 16 },
};

const EditIngredient = ({
  ingredients,
  ingredient,
  ingredientImages,
  uploadIngredientFile,
  fetchIngredientImages,
  updateIngredient,
  deleteIngredient,
  recipes,
  recipeTags,
  history,
  deleteRecipe,
}) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const { confirm } = Modal;

  const onFinish = (values) => {
    updateIngredient(ingredient.id, values);
  };

  const normalizedName = (name) => {
    const clean = name.trim().replace(/\s+/g, " ").toLowerCase();
    return (
      clean.charAt(0).toUpperCase() +
      clean.slice(1) +
      (name.endsWith(" ") ? " " : "")
    );
  };

  const onFinishFailed = () => {};

  const nameIsValid = (name) => {
    if (name === ingredient.name) {
      return true;
    }
    const existing = ingredients.reduce((acc, i) => {
      acc.push(
        i.name
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
      );
      return acc;
    }, []);
    return (
      existing.indexOf(
        name
          .trim()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
      ) < 0
    );
  };

  const onNameChange = (value) => {
    form.setFieldsValue({ name: normalizedName(value) });
  };

  const showDeleteConfirm = () => {
    confirm({
      title: (
        <p>
          Confirmer la suppression de
          <br /> {ingredient.name}
        </p>
      ),
      icon: <ExclamationCircleOutlined />,
      content: (
        <p>
          Attention les recettes qui l'utilisent ne seront plus valides
          <Input placeholder="Taper le nom de l'ingrédient pour valider" />
        </p>
      ),
      okText: "Oui",
      okType: "danger",
      okButtonProps: { icon: <DeleteOutlined /> },
      cancelText: "Non",

      onOk() {
        deleteIngredient(ingredient.id);
        message.success(
          "L'ingrédient \"" + ingredient.name + '" a été supprimé'
        );
      },
      onCancel() {},
    });
  };

  return (
    <>
      <Divider>Modifier un ingrédient</Divider>
      <h1 style={{ textAlign: "center" }}>{ingredient.name}</h1>
      <h1 style={{ textAlign: "center" }}>
        <Image
          width={200}
          height={200}
          src={ingredient.url}
          fallback="data:image/png;base64,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"
        />
      </h1>
      <Form
        {...layout}
        form={form}
        name="edit-ingredient"
        size="large"
        initialValues={{
          name: ingredient.name,
          img: ingredient.img,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="Nom"
          name="name"
          rules={[
            { required: true, message: "Le nom est requis!" },
            () => ({
              validator(rule, value) {
                if (value === undefined || nameIsValid(value)) {
                  return Promise.resolve();
                }
                return Promise.reject("L'ingrédient existe déja!");
              },
            }),
          ]}
        >
          <AutoComplete
            options={ingredients.map((i) => ({ value: i.name }))}
            filterOption={(inputValue, option) =>
              option.value
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toUpperCase()
                .indexOf(
                  inputValue
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toUpperCase()
                ) !== -1
            }
            onChange={onNameChange}
          />
        </Form.Item>
        <Form.Item
          label="Image"
          name="img"
          rules={[{ required: true, message: "Choisissez une image!" }]}
        >
          <Select placeholder="Choisir une image" allowClear>
            {Object.keys(ingredientImages).map((key) => {
              return (
                <Option key={key} value={key}>
                  <Tooltip title={key}>
                    <Avatar
                      shape="square"
                      size="default"
                      src={ingredientImages[key]}
                    >
                      {" "}
                    </Avatar>
                  </Tooltip>
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">
            <CloudUploadOutlined />
            Modifier
          </Button>
        </Form.Item>
      </Form>
      <Form {...layout} size="large">
        <Form.Item label="Importer une nouvelle image">
          <SVGFileLoader
            customUpload={({ onError, onSuccess, file }) => {
              uploadIngredientFile(file)
                .then(() => {
                  onSuccess(null, file);
                  fetchIngredientImages();
                  form.setFieldsValue({
                    img: file.name,
                  });
                })
                .catch((e) => {
                  onError(e);
                });
            }}
          />
        </Form.Item>
        <Form.Item label="Supprimer">
          <Button
            disabled={false}
            danger
            icon={<DeleteOutlined />}
            onClick={() => {
              showDeleteConfirm();
            }}
          >
            Supprimer l'ingrédient
          </Button>
        </Form.Item>
      </Form>
      <Divider>Recettes utilisant {ingredient.name}</Divider>
      <RecipeTable
        recipeTags={recipeTags}
        recipes={recipes}
        history={history}
        deleteRecipe={deleteRecipe}
      />
    </>
  );
};

export default EditIngredient;
